export const fontNames = {
  Inconsolata: "Inconsolata",
} as const;
